import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { zIndex } from "@repo/tokens";
import { useAuthStore } from "../../store/useAuthStore";
import { PageLoader } from "../common/PageLoader";
import { DeepLinkHandler } from "./DeepLinkHandler";

const SPINNER_DELAY_MS = 500;

/** Above modal overlays ({@link zIndex.modal}) so sync blocks interaction on open dialogs. */
const SYNC_BLOCKER_Z = zIndex.modal + 1;

export const DeepLinkSyncGuard = () => {
  const isSyncing = useAuthStore((s) => s.isSyncing);
  const showSpinner = useDelayedFlag(isSyncing, SPINNER_DELAY_MS);

  return (
    <>
      <DeepLinkHandler />
      
      {isSyncing ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: SYNC_BLOCKER_Z,
            pointerEvents: "auto",
            display: "flex",
            flexDirection: "column",
            backgroundColor: showSpinner ? undefined : "transparent",
          }}
        >
          {showSpinner ? <PageLoader /> : null}
        </div>
      ) : (
        <Outlet />
      )}
    </>
  );
};

function useDelayedFlag(flag: boolean, delayMs: number): boolean {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!flag) {
      setDelayed(false);
      return;
    }
    const id = window.setTimeout(() => setDelayed(true), delayMs);
    return () => window.clearTimeout(id);
  }, [flag, delayMs]);

  return delayed;
}
